import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    user_login_info: {
      org_name: "",
      username: "",
      email: "",
      nickname: "",
      quickPhrases: "",
      organize_id: "",
      rid: "",
      mg_state: 1,
      token: "",
      user_id: "",
      login_time: "",
    },
    isLoggedIn: false,
  },

  mutations: {
    SET_USER_LOGIN_INFO(state, userInfo) {
      state.user_login_info = { ...state.user_login_info, ...userInfo };
    },

    CLEAR_USER_LOGIN_INFO(state) {
      state.user_login_info = {
        org_name: "",
        nickname: "",
        username: "",
        email: "",
        quickPhrases: "",
        organize_id: "",
        rid: "",
        mg_state: 1,
        token: "",
        user_id: "",
        login_time: "",
      };
      state.isLoggedIn = false;
    },

    SET_LOGIN_STATUS(state, status) {
      state.isLoggedIn = status;
    },

    // 单独更新某个字段
    UPDATE_USER_FIELD(state, { field, value }) {
      if (state.user_login_info.hasOwnProperty(field)) {
        state.user_login_info[field] = value;
      }
    },
  },

  actions: {
    // 设置完整的用户信息
    setUserLoginInfo({ commit }, userInfo) {
      commit("SET_USER_LOGIN_INFO", userInfo);
      commit("SET_LOGIN_STATUS", true);

      // 可选：存储到 localStorage 持久化
      localStorage.setItem("user_login_info", JSON.stringify(userInfo));
      localStorage.setItem("isLoggedIn", "true");
    },

    // 从 localStorage 恢复登录状态
    initializeStore({ commit }) {
      if (localStorage.getItem("isLoggedIn")) {
        const userInfo = JSON.parse(
          localStorage.getItem("user_login_info") || "{}",
        );
        commit("SET_USER_LOGIN_INFO", userInfo);
        commit("SET_LOGIN_STATUS", true);
      }
    },

    // 清除用户信息（退出登录）
    clearUserInfo({ commit }) {
      commit("CLEAR_USER_LOGIN_INFO");
      localStorage.removeItem("user_login_info");
      localStorage.removeItem("isLoggedIn");
    },

    // 更新特定字段
    updateUserField({ commit }, { field, value }) {
      commit("UPDATE_USER_FIELD", { field, value });

      // 更新 localStorage
      const userInfo = JSON.parse(
        localStorage.getItem("user_login_info") || "{}",
      );
      userInfo[field] = value;
      localStorage.setItem("user_login_info", JSON.stringify(userInfo));
    },
  },

  getters: {
    // 获取完整用户信息
    getUserLoginInfo: (state) => state.user_login_info,

    // 获取特定字段
    getUserToken: (state) => state.user_login_info.token,
    getloginTime: (state) => state.user_login_info.login_time,
    getUserName: (state) => state.user_login_info.username,
    getUserId: (state) => state.user_login_info.user_id,
    getUserEmail: (state) => state.user_login_info.email,
    getOrganizationId: (state) => state.user_login_info.organize_id,

    // 检查是否已登录
    isAuthenticated: (state) =>
      state.isLoggedIn && !!state.user_login_info.token,
  },
});
